import React from 'react'
import PropTypes from 'prop-types'

import './tabs.scss'

const Tabs = ({ items, activeItem, onClick }) => (
	<div
		className="c-tabs"
		onClick={onClick}
		onKeyDown={onClick}
		role="link"
		tabIndex={0}
	>
		{[...items].map(item => (
			<span
				key={item}
				className={
					activeItem === item
						? 'c-tabs__link is-active'
						: 'c-tabs__link'
				}
				onKeyPress={() => {
					onClick(item)
				}}
				role="link"
				tabIndex={0}
				onClick={e => {
					e.preventDefault()
					onClick(item)
				}}
			>
				{item}
			</span>
		))}
	</div>
)

Tabs.propTypes = {
	items: PropTypes.instanceOf(Array).isRequired,
	activeItem: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
}

export default Tabs
